import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex: 1;
    padding: 1rem 0;
    border-bottom: 1px solid #1616163d;
    cursor: pointer;
    &:last-child {
        border-bottom: none;
    }
    &:hover {
        opacity: 0.85;
    }
`

export const Ico = styled.div`
    display: flex;
    align-items: flex-start;
    margin-right: 0.5rem;
    span {
        padding: 0;
    }
`

export const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 0.1rem 0;
`

export const Title = styled.div`
    display: flex;
    color: #363636;
    margin-bottom: 0.5rem;

    /* Mob/Interaction/lg */
    font-family: 'Dasa Sans';
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 1.5rem */
`

export const Subtitle = styled.div`
    display: flex;
    color: #666;

    /* Mob/Body/sm */
    font-family: 'Dasa Sans';
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 170%; /* 1.4875rem */
`

export const Chevron = styled.div`
    display: flex;
    align-items: center;
`
